import {Component, Input} from '@angular/core';
import {IOrder} from "../../../orders.interface";

@Component({
    selector: 'db-order-address',
    templateUrl: './order-address.component.html',
    styleUrl: './order-address.component.scss',
    standalone: false
})
export class OrderAddressComponent {
  @Input() order: IOrder;
  copyList = {
    shipping: {
      address1: false,
      address2: false,
      city: false,
      postcode: false,
      state: false,
      country: false,
    },
    billing: {
      address1: false,
      address2: false,
      city: false,
      postcode: false,
      state: false,
      country: false,
    },
  }
}
